import { createContext, useContext } from "react";
import { noop } from "@common/helpers/function";
import { RevertedFilterValue } from "@hooks/view/useHistoryPageFiltersCache";
import { ActivityOutcomeKind } from "@common/schemas/domains/activity/activity-outcomes.schema";
import { AuditChannel } from "@common/types/auditLog";
import { HistoryRow } from "./views/historyViewConfig";

export interface HistoryDrawerContextValue {
    open: boolean;
    historyRow: HistoryRow | null;
    revertedFilter?: RevertedFilterValue;
    channels?: AuditChannel[];
    outcome?: ActivityOutcomeKind;
    // True only when the rows were fetched with `groupByChannel`, so each
    // row's `channel` is meaningful and can be sent to details.
    isGroupedByChannel?: boolean;
    openDrawer: (row: HistoryRow) => void;
    closeDrawer: () => void;
}

export const historyDrawerContext = createContext<HistoryDrawerContextValue>({
    open: false,
    historyRow: null,
    revertedFilter: undefined,
    channels: undefined,
    outcome: undefined,
    isGroupedByChannel: undefined,
    openDrawer: noop,
    closeDrawer: noop,
});

export const useHistoryDrawer = () => useContext(historyDrawerContext);
